import { useSelectedChain } from "@app/examples/ChainSelector";
import { Baaanggg, CredentialRequest } from "baaanggg";
import { useCallback, useEffect, useState } from "react";
import useAlert, { AlertUtils } from "./AlertHook";
import { useWallet } from "@providers/wallet.provider";
import { ConnectedWallet } from "@goblinhunt/cosmes/wallet";


function makeClient(authCb: () => Promise<void>) {
    const apiUrl = "https://api-bigbangx.garuda-defi.org";

    return new Baaanggg(apiUrl, {
        useLocalStorage: true,
        requestAuthCallback: authCb,
    });
}

export function useBaaanggg() {
    const alert = useAlert()
    // const apiUrl = "https://api.bigbangx.io";
    const apiUrl = "https://api-bigbangx.garuda-defi.org";
    // const apiUrl = "http://localhost:9999";

    const client = new Baaanggg(apiUrl, {
        useLocalStorage: true,
        requestAuthCallback: async () => Promise.reject()
    })
    const [baaanggg, setBaaanggg] = useState<Baaanggg>(client)
    const { wallet, address, disconnect } = useWallet()

    useEffect(() => {
        if (address) {
            const client: Baaanggg = new Baaanggg(apiUrl, {
                useLocalStorage: true,
                requestAuthCallback: async () => await signIn(alert, wallet, address, client, () => disconnect())
            })
            setBaaanggg(client)
        }
    }, [address])

    return baaanggg
}


export function useAuthClient() {
    const alert = useAlert();
    const { wallet, address, disconnect } = useWallet();

    // client default: belum login -> tolak auth request
    const [client, setClient] = useState(() => makeClient(() => Promise.reject()));

    const signInCall = useCallback(async () => {
        console.log("asd")
        if (!address) {
            alert?.error?.("Connect wallet dulu.");
            throw new Error("Wallet/address not available");
        }

        const authed = makeClient(async () => {
            await signIn(alert, wallet, address, authed, () => disconnect());
        });



        setClient(authed);
    }, [alert, wallet, address, disconnect]);

    return { client, signInCall };
}

const signIn = async (
    alert: AlertUtils,
    wallet: ConnectedWallet, // ini instance dari cosmes
    address: string,
    baaanggg: Baaanggg,
) => {
    try {
        const walletAddress = address;

        // Pastikan sudah register
        const response = await baaanggg.user.isRegistered(walletAddress)
        if (!response.isRegistered) throw "Account not registered yet"

        // Pesan HARUS persis kayak yang di-backend
        const msg = {
            type: "/user/Authenticate",
            address: walletAddress
        }
        const msgJson = JSON.stringify(msg);

        alert.loading("Request auth signing, please check your wallet")
        const result = await wallet.signArbitrary(msgJson);
        console.log(wallet.type)

        const credential: CredentialRequest = {
            publicKey: result.pubKey,
            signature: result.signature,
            walletAddress,
            walletType: wallet.type
        };

        await baaanggg.auth.signIn(credential);
        alert.hide();

    } catch (e) {
        // onFailed();
        // alert.hide();
        // throw e;
    }
}

